interface CircularAcronymsDataModel {
  text: string;
  width: number;
  height: number;
  imageUrl?: string;
}

const CircularAcronyms: React.FC<CircularAcronymsDataModel> = ({
  text,
  width,
  height,
  imageUrl,
}) => {
  return (
    <div
      style={{
        width: width,
        height: height,
        borderRadius: width,
        borderColor: '#6a6a6a',
        borderWidth: '1px',
        borderStyle: 'solid',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={text}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: width,
          }}
        />
      ) : (
        text
      )}
    </div>
  );
};

export default CircularAcronyms;
